import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";
import { modalStyle } from "../../../../../../../../components/modalStyle";

import MrqDetails from "../../MRQTab/components/MrqDetails";
import GroupingTable from "../../DrawingBom/components/Tables/GroupingTable";
import { DrawingBomContext } from "../../DrawingBom/DrawingBomContext";
import { useMcsContext } from "../../../MCS.context";

export default function UpdateMrqBtn({
  parent,
  material,
  drawing,
  previousDrawing,
}) {
  const {
    changeSelectionMaterials,
    onReviseMrq,
    onUpdateRevisedMrq,
    consolidatedMaterials,
    mrqMaterials,
    setMrqMaterials,
  } = React.useContext(DrawingBomContext);
  const { plant } = useMcsContext();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const co = material?.changeOrders?.[0]?.changeOrder;
  // console.log("material in mrq revise btn", co);
  const coMaterials = co?.materials?.map((m) => m.material);
  const rev = drawing?.revision;

  let previousMrq = {};
  const previousMrqDrawingMaterials = [];

  previousDrawing?.materials.forEach((m) => {
    if (
      (material?.taggedMaterial?.tagNumber === m.taggedMaterial?.tagNumber ||
        material?.item === m.item) &&
      m.mrqMaterials?.[0]?.mrq?.id
    ) {
      previousMrq = m.mrqMaterials?.[0]?.mrq;
      //   previousMrqDrawingMaterials.push(m);
    }
  });

  previousDrawing?.materials.forEach((m) => {
    if (m.mrqMaterials?.[0]?.mrq?.id === previousMrq?.id) {
      previousMrqDrawingMaterials.push(m);
    }
  });

  const currentUpdatedMaterials = [];

  previousMrqDrawingMaterials.forEach((pm) => {
    drawing?.materials?.forEach((cm) => {
      (cm.taggedMaterial?.tagNumber === pm.taggedMaterial?.tagNumber ||
        cm.item === pm.item) &&
        cm.description !== pm.description &&
        pm.mrqMaterials?.[0]?.poId &&
        currentUpdatedMaterials.push(cm);
    });
  });

  console.log("currMrq", currentUpdatedMaterials);

  const onClick = () => {
    const drawingSelectedMaterials = {};
    console.log("comMaterila", coMaterials);
    drawingSelectedMaterials[drawing.id] = coMaterials;
    console.log("drawingSelectedMaterials", drawingSelectedMaterials);
    changeSelectionMaterials(drawingSelectedMaterials);

    const isConsolidated = onReviseMrq();

    if (isConsolidated) {
      handleOpen();
    }
  };

  const mrqDetails = {
    ...previousMrq,
    parentId: previousMrq?.id,
    rev: (Number(previousMrq?.rev) + 1 || 1).toString(),
  };
  delete mrqDetails?.id;

  const onUpdate = () => {
    onUpdateRevisedMrq({ mrq: mrqDetails, drawings: [drawing] });
    // TODO: handleclose;
  };

  return (
    <>
      <Button
        onClick={onClick}
        size="small"
        variant={parent === "coModal" ? "contained" : "outlined"}
      >
        Revise MRQ
      </Button>

      <Modal open={open} onClose={handleClose}>
        <Box sx={{ ...modalStyle }}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
          >
            Update Change Order ({"CO-0" + (rev ? rev : 0)}) MRQ materials:
          </Typography>

          <Box>
            <GroupingTable
              consolidatedMaterials={consolidatedMaterials}
              mrqMaterials={mrqMaterials}
              setMrqMaterials={setMrqMaterials}
            />
          </Box>

          <Box sx={{ py: 2 }}>
            <MrqDetails
              plant={plant}
              mrq={mrqDetails}
              addCopyBtn={false}
              focusOnRev
            />
          </Box>

          <Box
            sx={{
              mt: 2,

              textAlign: "right",
            }}
          >
            <Button
              color="error"
              variant="outlined"
              onClick={handleClose}
              sx={{ ml: 1 }}
            >
              Close
            </Button>

            <Button variant="contained" onClick={onUpdate} sx={{ ml: 1 }}>
              Update Mrq
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
